/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2024-07-26 09:55:36
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-07-26 09:57:17
 * @FilePath: /Client/src/plugins/axios.ts
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import store, { useSite2Station, useSite, isJA } from '../store'
import { ref, watch } from 'vue'
import router from '@/router'
// import dayjs from 'dayjs'
// import utc from 'dayjs/plugin/utc'
// import timezone from 'dayjs/plugin/timezone'
import { ElMessage as message } from 'element-plus'
import { isAxiosTime } from '@/util/common'
import { text, message as messageList, t as i18n } from '@/plugins/i18n'
import { debounce } from 'lodash'
// import gray from '@sniff/gray'
import { save } from '@/util/useBury'
import bus from '@/util/useBus'

const t: Record<string, string> = {
  master: 'https://master-gateway.theckb.com',
  test01: 'https://test01-gateway.theckb.com',
  test02: 'https://test02-gateway.theckb.com',
  test03: 'https://test03-gateway.theckb.com',
  dev: 'https://dev-gateway.theckb.com',
  cdn: 'https://test-al-gateway.theckbs.com',
  undefined: 'https://master-gateway.theckb.com'
}
const dynURL: string | undefined =
  t[(location.host.match(/(.*?)-/) ?? [])[1] as string]
export const baseURL = process.env.VUE_APP_URL || 'https://gateway-prod.theckb.com'
const X_GRAY_TAG = process.env.VUE_APP_X_GRAY_TAG || ''
console.log('process.env', process.env, X_GRAY_TAG)
// const graify = gray(baseURL)
// 报错不抛出
const whiteList = [
  '/settlement/wallet/getFundDetailByPlatformOrderNo',
  '/settlement/exchangeRate/cnyToJpyExchangeRateAfterConfigFloat',
  '/customer/checkPalletWhite',
  'goods/productAtlas/openShareLink',
  '/order/excel/batchPay',
  '/api/tts/uploadImage',
  '/api/thirdShopOrder/createPlatformOrders'
]
// 报错code不提示
// TODO:'-3', '24010064' 这两个code需要后期删除
const whiteCodeList = ['22010029', '22110002', '-3', '24010064', '240300029', '26000095', '240300038', '260000001', '410000003', '40000308', '220101026']
// dayjs.extend(utc)
// dayjs.extend(timezone)

// console.log(dayjs().tz('Hongkong').format())
// const unitTime = (time: string) => Date.now()

const _axios = axios.create({
  timeout: 3 * 60 * 1000,
  baseURL,
  withCredentials: false
})

const axiosV = axios.create({
  timeout: 3 * 60 * 1000,
  baseURL
})

const validVersion = debounce(() => {
  const curVersion = window.curVersion ?? {}
  if (curVersion.time + 10 * 60 * 1000 > Date.now()) {
    //
  } else {
    // 1:client 2:system 3:wms
    axiosV.post('/customer/getClientVersion?project=1').then((res) => {
      console.log(res)
      if (!curVersion.version) {
        //
      } else if (curVersion.version !== res?.data?.data) {
        requestAnimationFrame(() => {
          location.href = location.href + `${location.href.includes('?') ? '&' : '?'}_t_=${Date.now()}`
        })
      }
      curVersion.version = res?.data?.data
      curVersion.time = Date.now()
      window.curVersion = curVersion
    })
  }
}, 300)

declare global {
  export interface Window {
    curVersion: { time: number; version: string };
  }
}
const count = ref(0)
watch(count, async (v) => store.commit('status/reqingNum', v))
export const handleRequest = async function (config: AxiosRequestConfig) {
  validVersion()
  count.value++
  const cacheToken = store.getters.token
  const cacheCurShop = store.getters.curShop
  const token = cacheToken
  //  同步登录
  // if (!cacheToken) {
  //   store.dispatch('route/changeToken', null)
  // }
  if (token) {
    // 切换店铺要用！！！getCustomerDetails不能有shopId
    // 避免此问题
    const shopId = config.url?.includes('getCustomerDetails')
      ? ''
      : cacheCurShop
    config.headers = {
      ...config.headers,
      Accept: 'application/json, text/plain',
      'X-AuthToken': token,
      'X-AuthShopId': shopId ?? '',
      'X-stationCode': useSite2Station(),
      'X-GRAY-TAG': X_GRAY_TAG,
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc',
      'Cache-Control': 'no-store',
      'X-Url': location.href
    }
  } else {
    config.headers = {
      ...config.headers,
      Accept: 'application/json, text/plain',
      'X-stationCode': useSite2Station(),
      'X-GRAY-TAG': X_GRAY_TAG,
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc',
      'X-Url': location.href
    }
  }
  // await graify(config as any)
  return config
}
export const handleRequestError = async function (error: any) {
  return Promise.reject(error)
}
_axios.interceptors.request.use(handleRequest, handleRequestError)

// 错误提示
function wrap () {
  const cache: any = {}
  function debounce (fn: any) {
    return (msg: any) => {
      if (cache[msg]) return
      cache[msg] = true
      fn(msg)
      setTimeout(() => {
        delete cache[msg]
      }, 3000)
    }
  }
  return debounce
}
const error = wrap()(message.error.bind(message))

const updateState = debounce((url) => {
  const white = [
    '/order/cart/getCurrentCartList',
    '/customer/notify/get/private/unread/count'
  ]
  const token = store.getters.token
  if (!token) return
  if (url && white.includes(url)) return
  window.postMessage({ updateGlobalState: true }, '*')
  localStorage.setItem(
    '_update_global_state_',
    Math.random().toString().slice(2)
  )
}, 3000)

export const getHandleResponse = (isInCludeData?: boolean) => {
  return async function (response: AxiosResponse) {
    count.value--
    const data = response.data
    const success = data.code === '0'
    if (response.request?.responseType === 'blob') {
      return isInCludeData ? response : data
    }
    if (response.request?.responseType === 'arraybuffer') {
      return isInCludeData ? response : data
    }
    // console.log(`URL:${response?.config?.url},`, data);
    const codeMessage = messageList.code[useSite()]
    updateState(response?.config?.url)
    // console.log(`URL:${response?.config?.url},`, data)

    if (!success) {
      if (response.config.url?.includes('error_silent=true')) return
      if (data.code === '240000048') {
        bus.emit('orderExhausted')
      } else if (['22041007', '33010009', '33010008'].includes(data.code)) {
        error(data.msg)
      } else if (data.code === '24100002' && JSON.parse(response?.config?.data ?? '{}')?.from === 'index') {
        error(i18n('使用插件，您可以将1688等平台产品直接添加到THE CKB购物车中。'))
      } else if (data.code === '24220002') {
        // 没有店铺弹窗创建店铺
        store.commit('status/toCreateShop', true)
      } else if (data.code === '219000002') {
        const msg: any = {
          ja: `入力された店舗が既に【${data.msg}】店舗と連携済であるため、別の店舗を変更して再度連携することはできません`,
          en: `The store you entered is already associated with this store [${data.msg}] and cannot be associated with another store for duplicate purposes`,
          ko: `입력한 스토어가 이미 이 스토어와 연결되어 있습니다 [${data.msg}]. 중복 목적으로 다른 스토어와 연결할 수 없습니다.`
        }
        error(msg[useSite()])
      } else if (data.code === '24010003') {
        error(codeMessage[data.code] ?? (`【${data.code}】${codeMessage.noMatch}`))
        return data
      } else if (data.code === '22010003') {
        error(i18n('单笔订单价值不得超过XX元，请调整商品数量').replace(
          'XX',
          String(store.getters['d2cOrderAmount/getD2cMoney'])
        ))
        return data
      } else if (data.code === '21000024') {
        // https://devops.aliyun.com/projex/bug/DFPI-6006# 《【API | 取消授权】取消授权时，页面提示【21000024】，要求不报错》
        // 商品命中黑名单，商品详情无法打开，给个专门的报错页面
      } else if (data.code === '29040001' || data.code === '29040003') {
        // error(i18n('抱歉，该商品暂不支持购买'))
        // debugger
        location.href = '/blacklist'
      } else if (whiteCodeList.includes(data.code)) {
        // 不报错
      } else {
        if (!store.getters.isLogin) {
          if (['24010061', '10000000'].includes(data.code)) {
          } else {
            error(codeMessage[data.code] ?? (`【${data.code}】${codeMessage.noMatch}`))
          }
        } else {
          if (whiteList.find((i: any) => response.request?.responseURL?.indexOf(i) > -1)) {
          } else if (['40000307'].includes(data.code)) {
            error(data?.msg)
          } else {
            error(codeMessage[data.code] ?? (`【${data.code}】${codeMessage.noMatch}`))
          }
        }
      }
      save({
        type: 'responsefail',
        case: {
          url: response.config?.url ?? '',
          status: data?.code,
          text: data?.msg
        }
      })
    } else {
      save({
        type: 'response',
        case: {
          url: response.config?.url ?? '',
          status: response.status,
          res: {
            code: response.data.code,
            data: Object.prototype.toString.call(response.data?.data)
          }
        }
      })
    }
    // {"msg":"用户token过期","code":"24010062"}
    // { msg: '未登录',code: '10000000' }
    if (data.code === '24010062' || data.code === '10000000' || data.code === '24010061' || data.code === '24010063') {
      // debugger
      // alert(response.config?.url)
      store.dispatch('route/changeToken', null)
    }

    if (isInCludeData) {
      return {
        data: { success, ...data }
      }
    }
    return { success, ...data }
  }
}
export const handleResponseError = function (error: any) {
  save({
    type: 'responsefail',
    case: {
      url: error?.config?.url,
      status: error?.response?.status,
      text: error?.response?.statusText
    }
  })
  count.value--
  return Promise.resolve(error)
}

_axios.interceptors.response.use(getHandleResponse(false), handleResponseError)

export default (app: any): void => {
  app.config.globalProperties.http = _axios
}

export const http = _axios

// export const get = http.get.bind(http)

// export const post = http.post.bind(http)

export const get = <T = any, R = AxiosResponse<T>['data'], D = any>(
  url: string,
  config?: AxiosRequestConfig<D>
): Promise<R> => {
  const params = isAxiosTime(config?.params)
  return http.get(url, { ...config, params })
}
export const req = (url: string, params: any): Promise<any> =>
  get(url, { params })

export const post = <T = any, R = AxiosResponse<T>['data'], D = any>(
  url: string,
  data?: D,
  config?: AxiosRequestConfig<D>
): Promise<R> => {
  const newData = isAxiosTime(data)
  return http.post(url, newData, config)
}
